import { Dialog, Grid } from '@material-ui/core';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { ApproveEnrollmentIcon } from '../../icons';
import { getDatetimeText } from '../../utils/getDatetimeText';
import { Container, Detail, StyledButton, Title } from './style';

type ApproveEnrollmentDialogProps = {
  merchantName: string;
  referenceNumber: string;
  createdAt: string;
  open: boolean;
  onCancel?: () => void;
  onSubmit: () => void;
};

const ApproveEnrollmentDialog: FC<ApproveEnrollmentDialogProps> = (props) => {
  const { merchantName, referenceNumber, createdAt, open, onCancel, onSubmit } =
    props;
  const { t } = useTranslation();

  return (
    <Dialog open={open}>
      <Container>
        <ApproveEnrollmentIcon />
        <div>
          <Title>{t('dialog.approve_enrollment')}</Title>
        </div>
        <Detail>
          <span>{t('recurring_payment_detail.biller')}</span>
          <span> {merchantName || '-'}</span>
        </Detail>
        <Detail>
          <span>{t('recurring_payment_detail.reference_number')}</span>
          <span style={{ wordBreak: 'break-all' }}>
            {referenceNumber || '-'}
          </span>
        </Detail>
        <Detail className="last-child">
          <span>{t('recurring_payment_detail.enrollment_date')}</span>
          <span>
            {createdAt ? getDatetimeText(createdAt, 'shortDate') : '-'}
          </span>
        </Detail>
        <Grid container justify="space-between" spacing={1}>
          <Grid item xs={6}>
            <StyledButton size="small" variant="outlined" onClick={onCancel}>
              {t('dialog.cancel')}
            </StyledButton>
          </Grid>
          <Grid item xs={6}>
            <StyledButton
              color="primary"
              size="small"
              variant="contained"
              onClick={onSubmit}
            >
              {t('dialog.confirm')}
            </StyledButton>
          </Grid>
        </Grid>
      </Container>
    </Dialog>
  );
};

export default ApproveEnrollmentDialog;
